module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Hazel_30.48ccbb8b.png";